export default __webpack_public_path__ + "static/media/wallpaper.18ba5fef.avif";